import { Component, EventEmitter, Input, OnChanges, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  template: '',
  standalone: true
})
export class BaseModalComponent implements OnChanges {
  @Input() isLoading: boolean = false;
  @Output() confirm: EventEmitter<void | string> = new EventEmitter<void | string>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    protected config: NgbModalConfig,
    protected modalService: NgbModal
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const isLoadingChange: SimpleChange = changes['isLoading'];

    if (isLoadingChange && isLoadingChange.currentValue === false && isLoadingChange.previousValue === true) {
      this.close();
    }
  }

  protected open(content: any) {
    this.modalService.open(content);
  }

  protected close() {
    this.cancel.emit();
    this.modalService.dismissAll();
  }
}
